(function () {
  var PUBLIC_KEY = 'APP_USR-5f87c033-38c5-4e3c-9b4a-9ce69b41b31f';
  var cache = {};

  function formatBRL(value) {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function renderSummary(el, payerCosts) {
    var free = payerCosts.filter(function (cost) {
      return cost.installment_rate === 0;
    });
    var best = free.length ? free[free.length - 1] : payerCosts[0];

    if (!best || best.installments <= 1) {
      el.remove();
      return;
    }

    var suffix = free.length ? ' sem juros' : '';
    el.textContent = 'ou ' + best.installments + 'x de ' + formatBRL(best.installment_amount) + suffix;
    el.removeAttribute('data-loading');
  }

  function renderModalList(el, payerCosts) {
    el.innerHTML = '';

    payerCosts.forEach(function (cost) {
      var isFree = cost.installment_rate === 0;
      var isRecommended = (cost.labels || []).indexOf('recommended_installment') !== -1;

      var li = document.createElement('li');
      li.className = 'mp-installments-modal__item';
      if (isRecommended) li.classList.add('mp-installments-modal__item--recommended');

      var label =
        cost.installments === 1
          ? cost.installments + 'x de ' + formatBRL(cost.installment_amount) + ' à vista'
          : cost.installments + 'x de ' + formatBRL(cost.installment_amount);

      var tag = isFree
        ? '<span class="mp-installments-modal__tag">sem juros</span>'
        : '<span class="mp-installments-modal__tag mp-installments-modal__tag--interest">com juros</span>';

      var totalText = isFree
        ? ''
        : '<span class="mp-installments-modal__total">Total ' + formatBRL(cost.total_amount) + '</span>';

      li.innerHTML =
        '<span class="mp-installments-modal__item-main">' +
        '<span class="mp-installments-modal__label">' + label + '</span>' +
        tag +
        '</span>' +
        totalText;
      el.appendChild(li);
    });
  }

  function showLink(button) {
    if (button) button.hidden = false;
  }

  function fetchInstallments(amount) {
    if (cache[amount]) return cache[amount];

    var url =
      'https://api.mercadopago.com/v1/payment_methods/installments?public_key=' +
      PUBLIC_KEY +
      '&amount=' +
      amount +
      '&payment_method_id=visa&locale=pt-BR';

    cache[amount] = fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return (data && data[0] && data[0].payer_costs) || [];
      })
      .catch(function () {
        return [];
      });

    return cache[amount];
  }

  function init() {
    var groups = {};

    document.querySelectorAll('.mp-installments[data-amount]:not([data-mp-bound])').forEach(function (el) {
      el.setAttribute('data-mp-bound', 'true');
      var amount = el.getAttribute('data-amount');
      if (!amount || Number(amount) <= 0) {
        el.remove();
        return;
      }
      groups[amount] = groups[amount] || { summaries: [], lists: [] };
      groups[amount].summaries.push(el);
    });

    document
      .querySelectorAll('.mp-installments-modal__list[data-amount]:not([data-mp-bound])')
      .forEach(function (el) {
        el.setAttribute('data-mp-bound', 'true');
        var amount = el.getAttribute('data-amount');
        if (!amount || Number(amount) <= 0) return;
        groups[amount] = groups[amount] || { summaries: [], lists: [] };
        groups[amount].lists.push(el);
      });

    Object.keys(groups).forEach(function (amount) {
      fetchInstallments(amount).then(function (payerCosts) {
        if (!payerCosts.length) return;

        groups[amount].summaries.forEach(function (el) {
          var wrap = el.parentElement;
          renderSummary(el, payerCosts);
          var link = wrap && wrap.querySelector('.mp-installments__link');
          showLink(link);
        });

        groups[amount].lists.forEach(function (el) {
          renderModalList(el, payerCosts);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
